<template>
  <component :is="layout">
    <ModalIdle v-if="isIdle && isLoggedIn" />
    <router-view></router-view>
  </component>
</template>
<script>
import { mapState } from 'vuex'
import ModalIdle from '@/components/ModalIdle'
export default {
  name: 'App',
  data: function () {
    return {

    }
  },
  components: {
    ModalIdle
  },
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn
    }),
    layout () {
      return this.isLoggedIn ? 'member-layout' : 'guest-layout'
    },
    isIdle () {
      return this.$store.state.idleVue.isIdle
    }
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px; */
}
</style>
<style scoped>
#home,
#about,
#clients,
#testimonials,
#faq,
#register,
#contact {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/App.vue